import { IGlobalDateFilter } from "../models/filters/IFilters";

enum LegType {
  All = "arrival;departure",
  Arrival = "arrival",
  Departure = "departure",
  Mixed = "mixed",
}

enum ViewType {
  Flight = "flight",
  OTP = "otp",
  Baggage = "baggage",
}

export enum TrafficType {
  International = "International",
  Domestic = "Domestic",
}

const FlightsEnum = {
  LegType,
  ViewType,
  TrafficType,
};

export enum FlightLegTypeEnum {
  All = "all",
  Arrival = "arrival",
  Departure = "departure",
  Turnaround = "turnaround",
}

export default FlightsEnum;

export type FlightKPIUrlsType = {
  [key in KPISettingsIDs]?: string | undefined;
};

export type FlightKPIUrlsAndFilterHoursElement = {
  url: string | undefined;
  filterTime: {
    hours: number;
    minutes: number;
  };
  filterDate: IGlobalDateFilter;
};

export type FlightKPIUrlsAndFilterHours = {
  [key in KPISettingsIDs]?: FlightKPIUrlsAndFilterHoursElement;
};

export enum KPISettingsIDs {
  ON_TIME_PERFORMANCE = "onTimePerformance",
  TURNAROUND_SUFFICIENCY = "turnaroundSufficiency",
  RUNWAY_DELAY = "runwayDelay",
  SLOT_ADHERENCE = "slotAdherence",
  ADDITIONAL_DELAY = "turnaroundDelay",
  REGULATED_FLIGHT = "regulatedFlights",
}

export enum FlightStatus {
  ONTIME = "ON_TIME",
  EARLY = "EARLY",
  DELAYED = "DELAYED",
  CANCELLED = "CANCELLED",
  SCHEDULED = "SCHEDULED",
}
